import React from 'react';
import FilterWrap from 'components/atoms/FilterWrap';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';
import EnhancedTableWrap from 'components/molecules/MbTable/EnhancedTableWrap';
import moment from 'moment';
import { analysisMcTableStatistics, analysisMcStatistics } from 'lib/api/adex';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/styles';
import BasicTable from 'components/molecules/MbBasicTable';
import { makeHeadData } from 'lib/commonLib';
import TableContainer from 'components/molecules/MbTable';
import { makeRowColumn, getHeadObj } from 'lib/commonLib';

const style = (theme) => ({
  tableRoot: {
    borderTop: theme.palette.box.border,
    '& .mb-issue-table:not(:last-child)': {
      marginRight: 22,
    },
  },
  tableWrap: {
    display: 'inline-block',
    width: 502,
    marginTop: 28,
    verticalAlign: 'top',
  },
  tableTitle: {
    fontWeight: 'normal',
    fontSize: '15px',
    color: theme.palette.common.black,
    marginBottom: 9,
  },
  issueTable: {
    '& table': {
      tableLayout: 'fixed',
      '& td, & th': {
        boxSizing: 'border-box',
      },
    },
    '& .mb-raf': {
      color: theme.palette.common.blue,
      '&.mb-minus': {
        color: theme.palette.common.red,
      },
    },
    // 지출 테이블
    '&.ADVRTS_AMT': {
      '& .mb-siteName': {
        width: 136,
      },
      '& .mb-yAdvrtsAmt, & .mb-wAdvrtsAmt, & .mb-advrtsAmtRaf': {
        width: 122,
      },
    },
  },
});

const tableInfoJson = {
  WEEK_TABLE: {
    headList: [
      {
        id: 'STATS_DTTM',
        label: '날짜',
        orderFlag: true,
        type: 'string',
        format: '@',
      },
      {
        id: 'TOT_EPRS_CNT',
        label: '모비온 요청수',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'PAR_EPRS_CNT',
        label: '광고 요청수',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'EXL_ITL_EPRS_RATE',
        label: '게재율',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'CTR',
        label: 'CTR',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'CPC',
        label: 'CPC',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'ADVRTS_AMT',
        label: '소진금액',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
    ],
    sort: 'desc',
    order: 'STATS_DTTM',
  },
  DAY_TABLE: {
    headList: [
      {
        id: 'STATS_DTTM',
        label: '날짜',
        orderFlag: true,
        type: 'string',
        format: '@',
      },
      {
        id: 'TOT_EPRS_CNT',
        label: '모비온 요청수',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'PAR_EPRS_CNT',
        label: '광고 요청수',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'EXL_ITL_EPRS_RATE',
        label: '게재율',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'CTR',
        label: 'CTR',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'CPC',
        label: 'CPC',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'ADVRTS_AMT',
        label: '소진금액',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
    ],
    sort: 'desc',
    order: 'APP_CNT',
  },
  DATE_TABLE: {
    headList: [
      {
        id: 'STATS_DTTM',
        label: '날짜',
        orderFlag: true,
        type: 'string',
        format: '@',
      },
      {
        id: 'TOT_EPRS_CNT',
        label: '모비온 요청수',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'PAR_EPRS_CNT',
        label: '광고 요청수',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'EXL_ITL_EPRS_RATE',
        label: '게재율',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'CTR',
        label: 'CTR',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'CPC',
        label: 'CPC',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'ADVRTS_AMT',
        label: '소진금액',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
    ],
    sort: 'desc',
    order: 'APP_CNT',
  },
};

const customized = {
  STATS_DTTM: {
    makeHead: (headsMap) => {
      return `${getHeadObj(headsMap, 'STATS_DTTM').label}`;
    },
    makeBody: (rowObj, headsMap) => {
      const statsDttm = getHeadObj(headsMap, 'STATS_DTTM');
      const dateValue = makeRowColumn(
        rowObj['STATS_DTTM'],
        'date',
        'YYYY-MM-DD'
      );
      var dayOfWeek = new Date(dateValue).getDay();

      let dayColor;
      if (dayOfWeek === 0) {
        dayColor = {
          color: 'red',
        };
      } else if (dayOfWeek === 6) {
        dayColor = {
          color: 'blue',
        };
      }

      return (
        <>
          <p style={dayColor}>
            {makeRowColumn(
              rowObj['STATS_DTTM'],
              statsDttm.type,
              statsDttm.format
            )}
          </p>
        </>
      );
    },
  },
};

/**
 * 테이블 나오는 순서
 */
const tableOrder = [
  { key: 'WEEK_TABLE', label: '주간 비교' },
  { key: 'DAY_TABLE', label: '전일자 비교' },
  { key: 'DATE_TABLE', label: '기간 지정' },
];

let initialization = false;
let initParam = {
  sDate: moment().add(-3, 'day').format('YYYYMMDD'),
  eDate: moment().add(-3, 'day').format('YYYYMMDD'),
  diffSDate: moment().add(-2, 'day').format('YYYYMMDD'),
  diffEDate: moment().add(-2, 'day').format('YYYYMMDD'),
};
class AnalysisMcStatistics extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      list: {},
      // 공통 필터에서 초기값 받아왔는지 확인
      getInitParam: false,
      params: { ...initParam },
      selectedManagerIndex: 0,
    };
  }

  getData = () => {
    const { params } = this.state;

    this.setState({
      ...this.state,
      loading: true,
      list: {},
    });

    analysisMcTableStatistics({
      params,
    }).then((response) => {
      const { data } = response.data;

      this.setState({
        ...this.state,
        loading: false,
        list: {
          WEEK_TABLE: data.WEEK_TABLE,
          DAY_TABLE: data.DAY_TABLE,
          DATE_TABLE: data.DATE_TABLE,
        },
      });
    });
  };

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    const { params: prevParams } = prevState;
    const { params, loading } = this.state;

    if (JSON.stringify(prevParams) !== JSON.stringify(params)) {
      initialization = false;
      if (!loading) {
        this.getData();
      }
    }
  }

  /**
   * 필터 초기화
   */
  handleOnReset = () => {
    initialization = true;

    this.setState({
      ...this.state,
      params: { ...initParam },
      selectedManagerIndex: 0,
    });
  };

  getParam = (newParams) => {
    const { getInitParam } = this.state;
    initialization = false;
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }

    this.setState({
      ...this.state,
      getInitParam: true,
      params: {
        ...this.state.params,
        ...newParams,
      },
    });
  };

  render() {
    const { handleOnReset, getParam } = this;
    const { classes } = this.props;
    const { loading, list, getInitParam, params } = this.state;

    return (
      <>
        {getInitParam && (
          <EnhancedTableWrap>
            <div className={classes.tableRoot}>
              {(() => {
                const result = [];

                for (let i = 0; i < tableOrder.length; i++) {
                  const { key, label } = tableOrder[i];
                  const tableInfo = tableInfoJson[key];

                  result.push(
                    <div
                      key={key}
                      className={`${classes.tableWrap} mb-issue-table`}
                    >
                      <h3 className={classes.tableTitle}>{label}</h3>
                      <BasicTable
                        sort={tableInfo.sort}
                        order={tableInfo.order}
                        list={list[key]}
                        headCells={makeHeadData(tableInfo.headList)}
                        loading={loading}
                        className={`${classes.issueTable} ${key}`}
                        customized={customized}
                      />
                    </div>
                  );
                }
                return result;
              })()}
            </div>
          </EnhancedTableWrap>
        )}
        <FilterWrap handleOnReset={handleOnReset}>
          <StatisticsCommonFilter
            initialization={initialization}
            initData={initParam}
            useDiffDate={true}
            getParam={getParam}
            noneExternalFilter={true}
            nonePltfomTpCodeFilter={true}
            noneDisplayFilter={true}
          />
        </FilterWrap>
        <TableContainer
          className={classes.root}
          dataReqPromise={analysisMcStatistics}
          params={{ ...params }}
          sort="desc"
          order="STATS_DTTM"
          dense={true}
          customized={customized}
          hasExcel
        />
      </>
    );
  }
}

export default withTranslation()(withStyles(style)(AnalysisMcStatistics));
